import { FC } from 'react';
import { EmptyState, EmptyStateIcons, Icon, Icons } from '@silverfort/sf-components';
import { TopBarOptionItem } from './TopBarOptionItem';

const PolicyInsightsErrorPlaceholder: FC = () => {
    return (
        <div className="min-w-[290px] w-[290px] h-full bg-white shadow overflow-hidden flex flex-col">
            <div className="px-4 py-2 flex gap-2 items-center border-b border-sf-gray-100">
                <div className="flex items-center gap-1">
                    <Icon icon={Icons.Lightning} className="text-sf-gray-400" />
                    <span className="font-sf text-13 font-medium">Insights</span>
                </div>
            </div>
            <div className="px-2 py-1 border-b border-sf-gray-100 flex gap-2 hover:cursor-pointer">
                <TopBarOptionItem
                    disabled
                    title="Open"
                    leftProgressBarClassName="bg-sf-gray-50"
                    rightProgressBarClassName="bg-sf-gray-50"
                />
                <TopBarOptionItem
                    disabled
                    title="Resolved"
                    leftProgressBarClassName="bg-sf-gray-50"
                    rightProgressBarClassName="bg-sf-gray-50"
                />
            </div>
            <div className="w-full h-full flex-1 p-4">
                <EmptyState
                    title="We could not load insights"
                    icon={EmptyStateIcons.Error}
                    className="w-full h-full border border-sf-gray-100 rounded-[8px]"
                />
            </div>
        </div>
    );
};

export default PolicyInsightsErrorPlaceholder;
